import React from "react"
import CrewModal from "./AdvisoryBoardModal"

function Modal(props) {
  const [modalShow, setModalShow] = React.useState(false)
  const [isHovered, setIsHovered] = React.useState(false)

  const cardStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '1rem',
    borderRadius: '12px',
    backgroundColor: isHovered ? '#f8fafc' : 'transparent',
    transition: 'all 0.2s ease',
    cursor: 'pointer',
    border: '1px solid transparent',
    borderColor: isHovered ? '#e2e8f0' : 'transparent',
  }

  const photoStyle = {
    width: '150px',
    height: '150px',
    objectFit: 'cover',
    borderRadius: '8px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    flexShrink: 0,
  }

  const contentStyle = {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '1.25rem',
    flex: 1,
    minWidth: 0,
  }

  const nameRowStyle = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '0.75rem',
  }

  const nameStyle = {
    fontSize: '1.125rem',
    fontWeight: '600',
    color: '#1e3a5f',
    margin: 0,
    lineHeight: 1.3,
  }

  const emblemStyle = {
    width: '100px',
    height: 'auto',
    flexShrink: 0,
  }

  const positionStyle = {
    fontSize: '0.9375rem',
    fontWeight: '500',
    color: '#4a6fa5',
    marginTop: '0.375rem',
  }

  const rankStyle = {
    fontSize: '0.875rem',
    fontWeight: '400',
    color: '#64748b',
    marginTop: '0.25rem',
  }

  return (
    <>
      <div
        onClick={() => setModalShow(true)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="boardOfDirectorsModalButton"
        style={cardStyle}
      >
        {props.teamMemberPhoto && (
          <img
            src={props.teamMemberPhoto}
            alt={props.crewName}
            style={photoStyle}
          />
        )}
        <div style={contentStyle}>
          <div style={nameRowStyle}>
            <span style={nameStyle}>{props.crewName}</span>
            {props.emblem && (
              <img
                src={props.emblem}
                alt="Military insignia"
                style={emblemStyle}
              />
            )}
          </div>
          {props.position && (
            <span style={positionStyle}>{props.position}</span>
          )}
          {props.rank && (
            <span style={rankStyle}>{props.rank}</span>
          )}
        </div>
      </div>
      <CrewModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        position={props.position}
        crewName={props.crewName}
        modalContent={props.modalContent}
        teamMemberPhoto={props.teamMemberPhoto}
        emblem={props.emblem}
      />
    </>
  )
}

export default Modal
